export default __webpack_public_path__ + "static/media/no-notifications.1a88f30d.svg";